import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-menu-header',
    imports: [RouterModule],
    templateUrl: './menu-header.component.html',
    styleUrl: './menu-header.component.scss'
})
export class MenuHeaderComponent {

}
